import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const PrivacyPolicy = () => {
  const theme = useTheme();
  return (
    <Box sx={{ padding: 3, maxWidth: '800px', margin: '0 auto' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Privacy Policy</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Last Updated: 03/20/2025
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>1. Introduction</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Welcome to XFactual (“we”, “us”, “our”). This Privacy Policy explains how we collect, use, store, and protect your personal information when you use our Fact-Checking and AI Services (the “Service”) provided through our website and mobile application (“App”). By using our Service, you agree to the collection and use of your information in accordance with this policy.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>2. Information We Collect</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        We collect personal information such as your name, email address, and any other information you voluntarily provide when you create an account or contact us. We also automatically collect usage data including your IP address, browser type, operating system, pages viewed, and the dates/times of your visits. Additionally, cookies and similar tracking technologies are used to enhance your experience.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>3. How We Use Your Information</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Your data is used to provide, improve, and personalize our Service; to communicate with you; to analyze usage patterns; and to protect against fraudulent or unauthorized activity.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>4. Data Storage and Security</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        We implement reasonable technical and organizational measures to secure your personal data. However, no security system is completely secure, and we cannot guarantee absolute security.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>5. Third-Party Services</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        We rely on third-party services—including Microsoft Azure for database hosting and various API providers for our AI features—to help provide our Service. Their privacy practices may differ from ours, so please review their policies as well.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>6. Your Rights</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Depending on your jurisdiction, you may have the right to access, correct, update, or delete your personal information. Please contact us to exercise these rights.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>7. Changes to This Privacy Policy</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        We may update this Privacy Policy periodically. Changes will be posted on this page with an updated “Last Updated” date.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>8. Contact Us</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        If you have any questions or concerns about this Privacy Policy, please contact us at [Insert Email Address].
      </Typography>
      <Typography variant="caption" sx={{ mt: 3, display: 'block' }}>
        Disclaimer: The information provided in this app is as accurate as possible but may be incomplete or incorrect. Please verify critical information with additional sources. This app does not constitute professional advice and XFactual is not liable for any errors or omissions.
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
